import { MultiMetricComparisonVizViews } from '../types';
import { multiMetricComparisonBarChartViewConfig } from './bar-chart/view-config';
import { multiMetricComparisonTableViewConfig } from './table-view/view-config';

export const multiMetricComparisonViewConfigs = [
  {
    name: MultiMetricComparisonVizViews.BAR_CHART,
    viewConfig: multiMetricComparisonBarChartViewConfig,
  },
  {
    name: MultiMetricComparisonVizViews.TABLE_VIEW,
    viewConfig: multiMetricComparisonTableViewConfig,
  },
];
